export const serverPath = 'https://nimble-short-larkspur.glitch.me/';